<template>
  <div  :style='{width: panelWidth}' >
      <el-table ref='stppnltable' :data='tableData' class='riskTable' :height="panelHeight" style='width: 100%' fit
          :cell-class-name = "() => 'lu-click'"
          :row-class-name="tableRowClassName"
          @row-dblclick='(row, column) => row.instrumentName==="Realtime equity" ? showRealTimeEquityDialog(row, column) : getDetail(row.instrumentName)'
          @sort-change='sortChange'
       >
        <el-table-column prop='instrumentName' ref='sortCol1' sortable='custom' :sortKeys="['instrumentName']" sortFieldFormat="String" />
        <el-table-column align='center' :label="getCurrentSTPLabel">
          <el-table-column align='center' v-for='broker in stpBrokerList' :key='broker' :label='broker' ref='sortCol2' sortable='custom' :sortKeys="['stp',broker,'value']" sortFieldFormat="Number">
            <template slot-scope="data">
              <div style='text-align: right' :class='cellClass(data.row.stp[broker].value)'>{{ data.row.stp[broker].value | formatAmount(bookPnLMode) }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column align='center' :label='$t("Total")' prop='total' ref='sortCol3' sortable='custom' :sortKeys="['stp','total']" sortFieldFormat="Number">
            <template slot-scope="data">
              <div style='text-align: right' :class='cellClass(data.row.stp.total)'>{{ data.row.stp.total | formatAmount }}</div>
            </template>
          </el-table-column> -->
        </el-table-column>
      </el-table>

      <!-- <el-dialog v-el-drag-dialog  :title="$t('Config Book')" :visible.sync="showDialog" @close='onCloseDialog'>
              <book-config />
      </el-dialog> -->
      <el-dialog class="centered" :append-to-body="false" :modal="false" :title="dialogData.title" :visible.sync="dialogData.visible" @close='cancelRealTimeEquityDialog' width="30%">
        <lu-vbox lu-hcenter class='dialog-container'>
          <lu-hbox lu-hcenter lu-flex lu-vcenter class='pad-in-5 mar-t-10'>
            <lu-item lu-vcenter>{{ $t("Value") }}</lu-item>
            <lu-item lu-vcenter class='mar-l-10'><el-input-number v-model="dialogData.realTimeEquity" autosize :controls="false" /></lu-item>
          </lu-hbox>
          <lu-hbox lu-hcenter class='pad-in-5' style="margin-top: 30px;">
            <lu-item><el-button @click.native.prevent="validateRealTimeEquityDialog">{{ $t('Validate') }}</el-button></lu-item>
            <lu-item><el-button @click.native.prevent="cancelRealTimeEquityDialog">{{ $t('Cancel') }}</el-button></lu-item>
          </lu-hbox>
        </lu-vbox>
      </el-dialog>

        <el-drawer :append-to-body="true" ref="bookConfigDrawer" :title="$t('Book Config')" :visible.sync="showDialog" direction="rtl" size="80%" destroy-on-close :before-close="handleClose" :modal="false">
          <div class="handle-button-close" @click='closeDialog'>
            <i class="el-icon-close" />
          </div>
          <book-config defaultTab="stp" />
        </el-drawer>


      <!-- <right-panel :title="$t('Config Book')" v-if="showDialog" direction="rtl" ssize="50%">
        <book-config />
      </right-panel> -->
      
  </div>
</template>

<script>
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import elDragDialog from '@/directive/el-dragDialog'
import BookConfig from './components/bookConfig'
// import RightPanel from '@/components/RightPanel'
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'
import monitoringMixin from './mixins'
import { mapState } from 'vuex'

export default {
  name: 'STPPnL',
  directives: { elDragDialog },
  props: [ 'data', 'panel' ],
  mixins: [ monitoringMixin ],
  components: { LuVbox, LuHbox, LuItem, BookConfig },
  filters: {
    formatAmount (value, bookPnLMode) {
      if (!value) {
        return utils.formatAmount(0, 2, 3, bookPnLMode)
      }
      return utils.formatAmount(value, 2, 3, bookPnLMode)
    }
  },
  data: function () {
    return {
      showDialog: false,
      stpBrokerList: [],
      tableData: [],
      currentFilter: {},
      dialogData: {
        label: '',
        title: '',
        realTimeEquity: '',
        visible: false
      }
    }
  },
  watch: {
    data: {
      handler (value) {
        this.updateData(value)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({ includeMarkupsVal: state => state.settingsMonitor.settingParams.includeMarkups, panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    excelColumns () {
      let columns = []
      for (let i = 0; i < 26; i++) {
        columns.push(String.fromCharCode(0x41 + i))
      }
      for (let i = 0; i < 26; i++) {
        for (let j = 0; j < 26; j++) {
          columns.push(String.fromCharCode(0x41 + i) + String.fromCharCode(0x41 + j))
        }
      }
      return columns
    },
    bookPnLMode: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return tmp ? tmp.options.bookPnLMode : 0
    },
    getCurrentSTPLabel() {
      return this.getSTPLabel(this.bookPnLMode)
    },
    getCurrentDataField() {
      return this.getDataField(this.bookPnLMode)
    },
    getCurrentMode: function() {
      return this.getMode(this.bookPnLMode)
    },
    getLotsMios: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return !!tmp.options.lotsMios && tmp.options.lotsMios === 'lots' ? 'lots' : 'mios'
    }
  },
  methods: {
    sortChange: function(data) {
      const { column, order } = data

      let currentCol = this.getSortColumns().find(item => item.columnId === column.id)

      let sortKeys = []
      let sortFieldFormat = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        sortKeys = currentCol.$attrs.sortKeys
        sortFieldFormat = currentCol.$attrs.sortFieldFormat
      }

      this.currentFilter = { sortKeys, sortFieldFormat, order }
      this.dataSort()
    },
    getSortColumns: function() {
      let columns = []
      for (let ref of ["sortCol1", "sortCol2", "sortCol3"]) {
        if (this.$refs[ref]!==null && this.$refs[ref]!==undefined) {
          if (Array.isArray(this.$refs[ref])) {
            columns = columns.concat(this.$refs[ref])
          } else {
            columns.push(this.$refs[ref])
          }
        }
      }
      return columns
    },
    dataSort: function() {
      let { sortKeys, sortFieldFormat, order } = this.currentFilter
      if (!(Boolean(sortKeys) && Boolean(order))) {
        // default
        sortKeys = ['stp','total']
        sortFieldFormat = 'Number'
        order = 'descending'
        this.currentFilter = { sortKeys, sortFieldFormat, order }
      }
      this.tableData.sort(this.sortBy(sortKeys,sortFieldFormat,order))
    },
    sortBy: function(sortKeys,sortFieldFormat,order) {
      return function(a,b) {
        let value = 0

        const getPropValue = (data,sortKeys,sortFieldFormat) => {
          let currentData = data
          for (let key of sortKeys) {
            if (currentData!==null && currentData!==undefined && currentData.hasOwnProperty(key)) {
              currentData = currentData[key]
            }
          }
          if (typeof currentData === "object") {
            if (sortFieldFormat === 'String') {
              currentData = ''
            } else if (sortFieldFormat === 'Number') {
              currentData = 0
            } else {
              currentData = 0
            }
          }

          //format
          if (sortFieldFormat === 'String') {
            value = currentData.toUpperCase() 
          } else if (sortFieldFormat === 'Number') {
            if (!currentData) {
              currentData = 0
            }
            value = Math.abs(parseFloat(currentData))
          }
          return value
        }

        let valueA = getPropValue(a,sortKeys,sortFieldFormat)
        let valueB = getPropValue(b,sortKeys,sortFieldFormat)

        // ref 1
        if (a.instrumentName==='Realtime equity') {
          return -1
        }
        if (b.instrumentName==='Realtime equity') {
          return 1
        }

        // ref 2
        if (a.instrumentName==='Instrument') {
          return -1
        }
        if (b.instrumentName==='Instrument') {
          return 1
        }

        if (valueA>valueB) {
          // return 1
          return order==='ascending' ? 1 : -1
        }
        else if (valueA<valueB) {
          // return  -1
          return order==='ascending' ? -1 : 1
        }

        return 0
      }
    },
    updateData(value) {
      let data = this.parseData(value)
      this.stpBrokerList = data.stpBrokerList
      this.tableData = data.tableData
      this.dataSort()
      this.updateLayout()
    },
    updateLayout() {
      if (this.$refs.stppnltable && this.$refs.stppnltable.doLayout) {
          this.$refs.stppnltable.doLayout()
      }
    },
    getSTPLabel(bookPnLMode) {
      if (bookPnLMode) {
        return this.$t('STP Position')
      } else {
        return this.$t('STP PnL')
      }
    },
    getDataField(bookPnLMode) {
      if (bookPnLMode) {
        if (this.getLotsMios === 'lots') {
          return 'numberOfLot'
        } else {
          return 'exposure'
        }
      } else {
        return 'profitAndLoss' 
      }
    },
    getMode(bookPnLMode) {
      return bookPnLMode ? 'E' : 'P'
    },
    getExcelSheetName(bookPnLMode) {
      if (bookPnLMode) {
        return this.$t('STP Exposure')
      } else {
        return this.$t('STP PnL')
      }
    },
    parseData (value, bookPnLMode = this.bookPnLMode) {
      let stpBrokerList = []
      let tableData = []
      let stpHash = {}
      value.forEach(item => {
        let row = {
          instrumentName: item.instrumentName,
          label: item.label,
          stp: {},
          book: {},
          markupAmount: '',
          total: ''
        }

        if (item.hasOwnProperty(this.getDataField(bookPnLMode))) {
          row.stp.total = item[this.getDataField(bookPnLMode)]
        } else {
          row.stp.total = "0.00"
        }
        if (item.brokerList && item.brokerList.length) {
          item.brokerList.forEach(broker => {
            if (!stpHash[broker.brokerName]) {
              stpHash[broker.brokerName] = stpBrokerList.length + 1
              stpBrokerList.push(broker.brokerName)
            }
            if (broker.hasOwnProperty(this.getDataField(bookPnLMode))) {
              row.stp[broker.brokerName] = { value: broker[this.getDataField(bookPnLMode)], editable: broker.editable === 1 ? true : false }
            } else {
              row.stp[broker.brokerName] = { value: "0.00", editable: false }
            }
          })
        }

        tableData.push(row)
      })
      return {
        stpBrokerList: stpBrokerList,
        tableData: tableData
      }
    },
    onSettings () {
      this.showDialog = !this.showDialog
    },
    onChangeBookPnLMode () {
      this.updateData(this.data)
    },
    onChangeLotsMios () {
      this.updateData(this.data)
    },
    handleClose(done) {
      this.showDialog = false
      setTimeout(() => {
        done();
        // animation takes time
        setTimeout(() => {
        }, 400);
      }, 600);
    },
    closeDialog () {
      if (this.$refs.bookConfigDrawer)
        this.$refs.bookConfigDrawer.closeDrawer()
    },
    cellClass (value) {
      return value < 0 ? 'negative' : 'positive'
    },
    handleDownload (dataList, sheetOnly) {
      return import('@/vendor/Export2Excel').then(excel => {
        let sheetList = []
        const columns = this.excelColumns

        for (let bookPnLMode of [0,1]) {
          let data = this.parseData(dataList,bookPnLMode)

          // let headers = [
          //   [ this.$t('Instrument') ],
          //   [ this.$t('Instrument') ],
          //   [ this.$t('Instrument') ],
          // ]
          let headers = [
            [ '' ],
            [ '' ],
            [ '' ],
          ]

          let merges = [ 'A1:A3' ]

          let col = 1

          // let start = col

          // STP
          merges.push(columns[col] + '1:' + columns[col + data.stpBrokerList.length - 1] + '1')
          // merges.push(columns[col] + '1:' + columns[col + data.stpBrokerList.length] + '1')
          data.stpBrokerList.forEach(s => {
            headers[0].push(this.getSTPLabel(bookPnLMode))
            headers[1].push(s)
            headers[2].push(s)
            merges.push(columns[col] + '2:' + columns[col] + '3')
            col++
          })
          // merges.push(columns[col] + '2:' + columns[col] + '3')
          // col++

          // headers[0].push(this.getSTPLabel(bookPnLMode))
          // headers[1].push(this.$t('Total'))
          // headers[2].push(this.$t('Total'))

          let tableData = []
          data.tableData.forEach(row => {
            let thisRow = []
            thisRow.push(row.instrumentName)

            data.stpBrokerList.forEach(s => {
              thisRow.push(row.stp[s].value)
            })
            // thisRow.push(row.stp.total)

            tableData.push(thisRow)
          })

          sheetList.push({
            multiHeader: headers,
            data: tableData,
            merges: merges,
            sheetName: this.getExcelSheetName(bookPnLMode)
          })
        }

        if (sheetOnly) {
          // return sheetList
          return {
            isMultiTab: true,
            tabList: sheetList
          }
        } else {
          let filename = this.panel.exportExcelFilePrefix + '_' +  timestamp()

          excel.export_json_to_excel_lusis_multisheet({
            filename: filename,
            autoWidth: true,
            bookType: 'xlsx',
            sheets: sheetList
          })
        }
      })
    },
    getDetail: function (label) {
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'symbol', 'paramValue': label},
        {'paramName': 'mode', 'paramValue': this.getCurrentMode}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: 'symbol', value: label, params: params, show: true})
    },
    showRealTimeEquityDialog(row, column) {
      if (!column.label) {
        // do not show for first column
        return
      }

      let brokerName = column.label
      let currentValue = ""
      let editable = false
      if (row && row.stp && row.stp[brokerName]) {
        currentValue = row.stp[brokerName].value
        editable = row.stp[brokerName].editable
      }
      
      if (!editable) {
        // do not show if not editable
        return
      }

      this.dialogData.realTimeEquity = currentValue
      this.dialogData.label = brokerName
      this.dialogData.title = this.dialogData.label + ' - ' + this.$t('Realtime Equity')
      this.dialogData.visible = true
    },
    validateRealTimeEquityDialog() {
      let currentValue = 0
      if (this.dialogData.realTimeEquity) {
        currentValue = this.dialogData.realTimeEquity
      }
      let cond = {
        MTI: 4989,
        functionId: 'setLPEquity',
        origin: this.dialogData.label,
        AccountEquity: currentValue
      }

      this.$tango.request(cond).then(rep => {
        if (rep.resultCode === 0) {
          this.dialogData.visible = false
          this.$message({
            message: 'Validate Realtime Equity success',
            type: 'success'
          })
        }
        else {
          this.dialogData.visible = false
          this.$message({
            message: 'Validate Realtime Equity error',
            type: 'error'
          })
        }
      }).catch(() => {
        this.dialogData.visible = false
      })
    },
    cancelRealTimeEquityDialog() {
      this.dialogData.visible = false
    }
  }
}
</script>

<style>
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>